var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardWidget',{staticClass:"standalone-widget",style:(`width: ${_vm.width}px; height: ${_vm.height}px;`),attrs:{"value":_vm.value,"range":_vm.range,"public":"","uuid":_vm.uuid,"project-api-key":_vm.projectApiKey}})
}
var staticRenderFns = []

export { render, staticRenderFns }